import { RatesTableState, RatesHighlight } from "app/pages/AgentPricing/modules/RatesTableWidget/state";
import { SaveAgentCommissionDto, AgentCommissionCountryDto } from "app/shared/model/AgentCommissionDto";
import { RatesTable } from "app/pages/AgentPricing/models";

function getRoot(state: any) : RatesTableState {
    return state.ratesTable;
}

export function getRatesTable(state: any) : RatesTable {
    return getRoot(state).table; 
}

export function getRatesHighlightInfo(state: any) : RatesHighlight {
    return getRoot(state).highlight; 
} 

export function getSchoolOverrides(state: any) : string[] {
    const output : string[] = [];

    const table = getRoot(state).table;
    if (!table)
        return output;
    table.countries.forEach(c => {
        output.push(...c.columns.filter(s => s.isSchool).map(s => s.id));
    });

    return output;
}

export function getSaveAgentCommissionDto(state: any) : SaveAgentCommissionDto {
    const table = getRoot(state).table;
    if (table === undefined)
        throw new Error('No table to save');

    const rules = table.rules.map(x => x.code);

    const countries : AgentCommissionCountryDto[] =  
        table.countries.map(x => {
            const groupedItems = x.columns.map(col => {
                const rates : {[id: string]: string} = {};
                rules.forEach(r => {
                    rates[r] = table.rates[col.id + '|' + r]||'0'
                });

                return  {
                    isSchool: col.isSchool,
                    id: col.id,
                    percentageRates: rates,
                }
            });

            const country = groupedItems.find(x => !x.isSchool);

            return {
                allSchoolsSpecified: false, // doesn't matter
                countryId: x.id,
                percentageRates: country !== undefined ? country.percentageRates : {},
                schools: groupedItems.filter(y => y.isSchool).map(y => ({
                    schoolId: y.id,
                    percentageRates: y.percentageRates
                }))

            }
        })

    const result : SaveAgentCommissionDto = {
        startDate: table.dates.startDate,
        endDate: table.dates.endDate,
        countries: countries
    }

    return result;
}